import React from 'react';
export function BigIdea() {
  return <section aria-labelledby="bigidea-heading" className="w-full bg-sage text-white" data-id="element-18" data-mp="1vstwp7cd25n7">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-19" data-mp="2p8n99qo7kgl6">
        <h2 id="bigidea-heading" className="font-serif font-bold text-[26px] sm:text-4xl leading-[1.15] text-center" data-id="element-20" data-mp="2u8roldddr59t">
          La differenza tra un percorso che si ferma alla terza seduta e uno che
          arriva alla decima non è il talento.
        </h2>

        <p className="mt-6 text-center font-serif italic text-2xl sm:text-4xl text-terracotta" data-id="element-21" data-mp="26ixcwz4srmr5">
          È la struttura.
        </p>

        <p className="mt-8 text-white/85 text-base sm:text-lg leading-relaxed text-center max-w-2xl mx-auto" data-id="element-22" data-mp="2bhrvq12rlbb9">
          Il talento ti fa condurre una buona conversazione. La struttura ti fa
          condurre un percorso. E finora nessuno ti ha consegnato la struttura:
          non il master, non l&apos;attestato, non l&apos;ennesimo corso di
          tecniche.
        </p>

        <div className="mt-10 rounded-2xl bg-sage-dark border-l-4 border-terracotta px-6 py-6 sm:px-8 sm:py-7" data-id="element-23" data-mp="2u20un9we5ut8">
          <p className="font-serif font-bold text-lg sm:text-xl" data-id="element-24" data-mp="2p3zbkoyytvhr">
            Il punto in cui i percorsi si interrompono ha un nome: la Crisi
            della Quarta Seduta.
          </p>
          <p className="mt-3 text-white/80 text-[15px] sm:text-base leading-relaxed" data-id="element-25" data-mp="2g9b73117shu0">
            L&apos;entusiasmo iniziale è esaurito, la resistenza è comparsa, e
            il progresso non è ancora visibile. Il cliente conclude “forse non
            fa per me” e se ne va. Non è una tua mancanza. È un vuoto
            strutturale — e un vuoto strutturale si colma con una struttura, non
            con più empatia.
          </p>
        </div>
      </div>
    </section>;
}